import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { RealizationSummary } from "web_myplann/Goals/Components/RealizationSummary";
import { useRealizationContent } from "web_myplann/Goals/Hooks/useRealizationContent";
import type { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	category: GoalCategoryTypeEnum;
	submitLabel: string;
	cancelLabel: string;
	submitDisabled: boolean;
	isSubmitting: boolean;
	onCancel: () => void;
};

export const RealizationBox: FC<Props> = ({
	category,
	submitLabel,
	cancelLabel,
	submitDisabled,
	isSubmitting,
	onCancel,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const content = useRealizationContent(category);

	return (
		<Stack
			flex="1 0 auto"
			mt={1.2}
			px={2}
			pt={2}
			pb={theme.bottomSpacing.nativeBottomBar}
			sx={{ background: theme.gradients.realization }}
		>
			<RealizationSummary
				kicker={content.kicker}
				title={t(Resources.Goals.Form.Realization.defaultTitle)}
				description={content.description}
				steps={content.steps}
			/>

			<Typography
				variant="note"
				textAlign="center"
				mt={2}
				pt={2}
				borderTop={theme.colors.border.solid(theme.hero.divider)}
			>
				{t(Resources.Goals.Form.Realization.caption)}
			</Typography>

			<Stack mt={0.8} gap={0.4}>
				<Button
					type="submit"
					variant="primary"
					color="success"
					disabled={submitDisabled}
					loading={isSubmitting}
				>
					{submitLabel}
				</Button>
				<Button
					variant="textLink"
					color="neutral"
					onClick={onCancel}
					sx={{ width: "100%", justifyContent: "center", py: 0.8 }}
				>
					{cancelLabel}
				</Button>
			</Stack>
		</Stack>
	);
};
